import default_ from "./default.json" with { type: "json" };
import preLoginPages from "./preLoginPages.json" with { type: "json" };
import services from "./services.json" with { type: "json" };

export default {
	...default_,
	preLoginPages,
	services,
} as const;
